/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Vertical_Padding_HelpInputs */



/**
* | output |
* | --- |
* | "Top/bottom screen padding (0-50%)" |
*
* @param {Options_Display_Vertical_Padding_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_vertical_padding_help = /** @type {((inputs?: Options_Display_Vertical_Padding_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Vertical_Padding_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marge haut/bas de l'écran (0-50%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oberer/unterer Bildschirmabstand (0-50%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imbottitura superiore/inferiore dello schermo (0-50%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отступы сверху/снизу экрана (0-50%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno de pantalla superior/inferior (0-50%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕顶部/底部边距（0-50%）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面上部/下部のパディング（0～50%）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन के ऊपर/नीचे की पैडिंग (0-50%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Margem de preenchimento superior/inferior da tela (0-50%)")
	return /** @type {LocalizedString} */ ("Top/bottom screen padding (0-50%)")
});